module.exports = __webpack_public_path__ + "img/infoAccounting.a4d87199.png";